import {
  CONSOLE_RESET_STATE,
  CONSOLE_STATE_SUCCESSFUL,
  CONSOLE_STATE_FAILED,
  CONSOLE_COMPANY_LIST,
  CONSOLE_COMPANY_LIST_SUCCESSFUL,
  CONSOLE_COMPANY_LIST_FAILED,
  CONSOLE_SIGNUP_LIST,
  CONSOLE_SIGNUP_LIST_SUCCESSFUL,
  CONSOLE_SIGNUP_LIST_FAILED,
  CONSOLE_COPY,
  CONSOLE_COPY_SUCCESSFUL,
  CONSOLE_COPY_FAILED,
  CONSOLE_SHARE,
  CONSOLE_SHARE_SUCCESSFUL,
  CONSOLE_SHARE_FAILED,
  CONSOLE_SMS,
  CONSOLE_SMS_SUCCESSFUL,
  CONSOLE_SMS_FAILED,
  CONSOLE_RESPONSE_RESET_STATE,
  CONSOLE_RESPONSE_RESET_STATE_SUCCESSFUL,
  CONSOLE_RESPONSE_RESET_STATE_FAILED,
  CONSOLE_INVITE_SHARE,
  CONSOLE_INVITE_SHARE_SUCCESSFUL,
  CONSOLE_INVITE_SHARE_FAILED,
  CONSOLE_INVITE_SMS,
  CONSOLE_INVITE_SMS_SUCCESSFUL,
  CONSOLE_INVITE_SMS_FAILED,
  CONSOLE_CONNECT,
  CONSOLE_CONNECT_SUCCESSFUL,
  CONSOLE_CONNECT_FAILED,
} from "./actionTypes"

export const consoleResponseResetState = () => {
  return {
    type: CONSOLE_RESPONSE_RESET_STATE,
    payload: false,
  }
}

export const consoleResponseResetStateSuccessful = () => {
  return {
    type: CONSOLE_RESPONSE_RESET_STATE_SUCCESSFUL,
    payload: false,
  }
}

export const consoleResponseResetStateFailed = error => {
  return {
    type: CONSOLE_RESPONSE_RESET_STATE_FAILED,
    payload: error,
  }
}

export const consoleResetState = (error, history) => {
  return {
    type: CONSOLE_RESET_STATE,
    payload: { error, history },
  }
}

export const consoleResetStateSuccessful = history => {
  return {
    type: CONSOLE_RESET_STATE_SUCCESSFUL,
    payload: history,
  }
}

export const consoleResetStateFailed = error => {
  return {
    type: CONSOLE_RESET_STATE_FAILED,
    payload: error,
  }
}

export const consoleCompanyList = () => {
  return {
    type: CONSOLE_COMPANY_LIST,
    payload: { },
  }
}

export const consoleCompanyListSuccessful = data => {
  return {
    type: CONSOLE_COMPANY_LIST_SUCCESSFUL,
    payload: data,
  }
}

export const consoleCompanyListFailed = error => {
  return {
    type: CONSOLE_COMPANY_LIST_FAILED,
    payload: error,
  }
}

export const consoleCopy = (data, navigator) => {
  return {
    type: CONSOLE_COPY,
    payload: { data, navigator },
  }
}

export const consoleCopySuccessful = data => {
  return {
    type: CONSOLE_COPY_SUCCESSFUL,
    payload: data,
  }
}

export const consoleCopyFailed = error => {
  return {
    type: CONSOLE_COPY_FAILED,
    payload: error,
  }
}

export const consoleShare = data => {
  return {
    type: CONSOLE_SHARE,
    payload: { data },
  }
}

export const consoleShareSuccessful = data => {
  return {
    type: CONSOLE_SHARE_SUCCESSFUL,
    payload: data,
  }
}

export const consoleShareFailed = error => {
  return {
    type: CONSOLE_SHARE_FAILED,
    payload: error,
  }
}

export const consoleSms = data => {
  return {
    type: CONSOLE_SMS,
    payload: { data },
  }
}

export const consoleSmsSuccessful = data => {
  return {
    type: CONSOLE_SMS_SUCCESSFUL,
    payload: data,
  }
}

export const consoleSmsFailed = error => {
  return {
    type: CONSOLE_SMS_FAILED,
    payload: error,
  }
}

export const consoleSignupList = () => {
  return {
    type: CONSOLE_SIGNUP_LIST,
    payload: { },
  }
}

export const consoleSignupListSuccessful = data => {
  return {
    type: CONSOLE_SIGNUP_LIST_SUCCESSFUL,
    payload: data,
  }
}

export const consoleSignupListFailed = error => {
  return {
    type: CONSOLE_SIGNUP_LIST_FAILED,
    payload: error,
  }
}

export const consoleInviteShare = data => {
  return {
    type: CONSOLE_INVITE_SHARE,
    payload: { data },
  }
}

export const consoleInviteShareSuccessful = data => {
  return {
    type: CONSOLE_INVITE_SHARE_SUCCESSFUL,
    payload: data,
  }
}

export const consoleInviteShareFailed = error => {
  return {
    type: CONSOLE_INVITE_SHARE_FAILED,
    payload: error,
  }
}

export const consoleInviteSms = data => {
  return {
    type: CONSOLE_INVITE_SMS,
    payload: { data },
  }
}

export const consoleInviteSmsSuccessful = data => {
  return {
    type: CONSOLE_INVITE_SMS_SUCCESSFUL,
    payload: data,
  }
}

export const consoleInviteSmsFailed = error => {
  return {
    type: CONSOLE_INVITE_SMS_FAILED,
    payload: error,
  }
}

export const consoleConnect = data => {
  return {
    type: CONSOLE_CONNECT,
    payload: { data },
  }
}

export const consoleConnectSuccessful = data => {
  return {
    type: CONSOLE_CONNECT_SUCCESSFUL,
    payload: data,
  }
}

export const consoleConnectFailed = error => {
  return {
    type: CONSOLE_CONNECT_FAILED,
    payload: error,
  }
}
